import React, { useState, Fragment } from 'react';
import { Row } from 'reactstrap';
import { Colxx } from '../../../../components/common/CustomBootstrap';

import AriDatePicker from './AriDatePicker';
import AriRoomsTable from './AriRoomsTable';
import moment from 'moment';

export default function Index() {
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(
    moment()
      .add(30, 'days')
      .format('YYYY-MM-DD')
  );
  const getStartDate = date => {
    setStartDate(moment(date).format('YYYY-MM-DD'));
    setEndDate(
      moment(date)
        .add(30, 'days')
        .format('YYYY-MM-DD')
    );
  };

  return (
    <Fragment>
      <Row>
        <Colxx xxs="12" className="mb-4">
          <AriDatePicker getStartDate={getStartDate} />
          <AriRoomsTable startDate={startDate} endDate={endDate} />
        </Colxx>
      </Row>
    </Fragment>
  );
}
